module.exports = __webpack_public_path__ + "img/hero-image.7bcc8030.png";